// Mock data for EPIC Multi-Brand Outlet

export const storeInfo = {
  name: "EPIC",
  tagline: "Redefining Men's Fashion Since 2023",
  heroTagline: "That style you saw in Mumbai? We have it.",
  description: "Backed by 18+ years of retail expertise",
  phone: "+91 88015 55165",
  whatsapp: "+918801555165",
  address: "Karimnagar, Telangana",
  timings: "Open 365 Days | 10:30 AM - 9:30 PM",
  instagram: "https://www.instagram.com/epic.2022",
  instagramHandle: "@epic.2022",
  mapsUrl: "https://maps.app.goo.gl/bzLbdjd6mkxueouEA",
  googleReviewUrl: "https://g.page/r/YOUR_PLACE_ID/review",
  locations: [
    {
      name: "Karimnagar",
      address: "Karimnagar, Telangana",
      mapsUrl: "https://maps.app.goo.gl/bzLbdjd6mkxueouEA",
      phone: "+91 88015 55165",
      whatsapp: "918801555165",
      type: "Multi-Brand Outlet"
    },
    {
      name: "L&T Hyderabad",
      address: "L&T Metro Mall, Hyderabad",
      mapsUrl: "https://maps.app.goo.gl/xHx8hP8u3pc1gTbV9",
      phone: "+91 91828 53939",
      whatsapp: "919182853939",
      type: "Multi-Brand Outlet"
    },
    {
      name: "Rajahmundry",
      address: "Rajahmundry, Andhra Pradesh",
      mapsUrl: "https://maps.app.goo.gl/PKGf1PECQwDcVuir9",
      phone: "+91 81216 41216",
      whatsapp: "918121641216",
      type: "Exclusive Kids Store"
    }
  ]
};

export const brands = [
  {
    id: 1,
    name: "Benetton",
    description: "Italian Style & Colorful Casual Wear",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/United_Colors_of_Benetton_logo.svg/1200px-United_Colors_of_Benetton_logo.svg.png"
  },
  {
    id: 2,
    name: "Rare Rabbit",
    description: "Premium Contemporary Fashion",
    logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSxvx8qVLxPqJPxQvZxMxYxYxYxYxYxYxYxYg&s"
  },
  {
    id: 3,
    name: "Jack & Jones",
    description: "Scandinavian Denim & Streetwear",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Jack_%26_Jones_logo.svg/1200px-Jack_%26_Jones_logo.svg.png"
  }
];

export const storePhotos = [
  {
    id: 1,
    image: "https://customer-assets.emergentagent.com/job_multi-brand-hub-4/artifacts/8z20g50y_418fffee-1c67-47a7-b099-ddc7e683894a.jpeg",
    alt: "EPIC Store Exterior"
  },
  {
    id: 2,
    image: "https://customer-assets.emergentagent.com/job_multi-brand-hub-4/artifacts/ckakaib6_IMG_8757.jpeg",
    alt: "EPIC Multi-Brand Showcase"
  },
  {
    id: 3,
    image: "https://customer-assets.emergentagent.com/job_multi-brand-hub-4/artifacts/0u4wq6xi_IMG_8738.jpeg",
    alt: "Store Interior View"
  }
];

export const collections = [
  {
    id: 1,
    title: "Rare Rabbit",
    description: "Contemporary fashion with vibrant color palettes",
    image: "https://customer-assets.emergentagent.com/job_multi-brand-hub-4/artifacts/wqkvrazw_IMG_8759.jpeg",
    category: "Lifestyle",
    brand: "Rare Rabbit"
  },
  {
    id: 2,
    title: "Floral Statements",
    description: "Bold patterns that define modern style",
    image: "https://customer-assets.emergentagent.com/job_multi-brand-hub-4/artifacts/r49p7th5_IMG_8760.jpeg",
    category: "Contemporary",
    brand: "Rare Rabbit"
  },
  {
    id: 3,
    title: "United Colors",
    description: "Bold, vibrant colors that define Benetton style",
    image: "https://customer-assets.emergentagent.com/job_multi-brand-hub-4/artifacts/s94ddbsq_IMG_8761.jpeg",
    category: "Casual Wear",
    brand: "Benetton"
  },
  {
    id: 4,
    title: "Kids Collection",
    description: "Premium fashion for the young ones",
    image: "https://customer-assets.emergentagent.com/job_multi-brand-hub-4/artifacts/l19hd5hx_IMG_8762.jpeg",
    category: "Kids Fashion",
    brand: "Benetton Kids"
  },
  {
    id: 5,
    title: "Perfect Fit Denim",
    description: "Precision crafted for the modern fit",
    image: "https://customer-assets.emergentagent.com/job_multi-brand-hub-4/artifacts/oy7gf886_IMG_8766.jpeg",
    category: "Denim",
    brand: "Jack & Jones"
  },
  {
    id: 6,
    title: "United Colors of Benetton",
    description: "Italian style meets modern casual elegance",
    image: "https://customer-assets.emergentagent.com/job_multi-brand-hub-4/artifacts/2b3xjx0b_IMG_8755.jpeg",
    category: "Store Experience",
    brand: "Benetton"
  }
];

export const offers = [
  {
    id: 1,
    title: "Exclusive Store Offers",
    description: "Visit our store to discover the latest deals and seasonal promotions across all premium brands",
    badge: "In-Store Only",
    cta: "Visit Store"
  }
];
